export default {"src":"/_next/static/media/circle-check-big.1e89abf7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};